export default {
    path: '/display/main/about',
    component: () => import('@/layout/default'),
    children: [
        {
            path: '/',
            component: () => import('@/pages/display/main/about/index.vue')
        }
    ]
};
